import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { Globals } from '../_globals/globals';
import { MessageService } from '../_services/message.service';
import { DeliveryRoute } from '../_models/delivery_route';

@Injectable({
  providedIn: 'root'
})
export class DeliveryRouteService {

  constructor(
    private http: HttpClient,
    private globals: Globals,
    private messageService: MessageService
  ) {}

  getDeliveryRoutes(searchParams: any): Observable<any> {
    let params = new HttpParams();
    if (searchParams !== null && searchParams !== undefined) {
      for (const key in searchParams) {
        if (searchParams.hasOwnProperty(key) &&
            searchParams[key] !== null &&
            searchParams[key] !== undefined &&
            searchParams[key] !== '') {
          params = params.set(key, searchParams[key]);
        }
      }
    }
    return this.http.get<any>(this.globals.apiUrl + '/delivery_routes', { params: params })
      .pipe(
        tap(_ => this.log('rutas de entrega cargadas')),
        catchError(this.handleError<any>('getDeliveryRoutes', []))
      );
  }

  createDeliveryRoute(routeIn: DeliveryRoute): Observable<DeliveryRoute> {
    return this.http.post<DeliveryRoute>(this.globals.apiUrl + '/delivery_route', routeIn)
      .pipe(
        tap(_ => this.log('ruta de entrega creada')),
        catchError(this.handleError<DeliveryRoute>('createDeliveryRoute', null))
      );
  }

  updateDeliveryRoute(routeIn: DeliveryRoute): Observable<DeliveryRoute> {
    return this.http.put<DeliveryRoute>(
      this.globals.apiUrl + '/delivery_route',
      routeIn,
      { params: new HttpParams().set('id', routeIn.id.toString()) }
    ).pipe(
      tap(_ => this.log('ruta de entrega actualizada')),
      catchError(this.handleError<DeliveryRoute>('updateDeliveryRoute', null))
    );
  }

  deleteDeliveryRoute(routeIn: DeliveryRoute): Observable<number> {
    return this.http.delete<number>(
      this.globals.apiUrl + '/delivery_route',
      { params: new HttpParams().set('id', routeIn.id.toString()) }
    ).pipe(
      tap(_ => this.log('ruta de entrega eliminada')),
      catchError(this.handleError<number>('deleteDeliveryRoute', null))
    );
  }

  private log(message: string) {
    this.messageService.add('DeliveryRouteService: ' + message);
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      this.log(operation + ' failed: ' + error.message);
      return of(result as T);
    };
  }
}
